import React, { useCallback, useMemo } from 'react';
import { connect } from "react-redux";
import { s3FeatureImagePath, THUMBNAIL_SIZES } from "../../../../../../../../misc/utils";
import {
  getDepthFromDbFeature,
  getHeightFromDbFeature,
  getRelatedFeatureMetadata,
  getWidthFromDbFeature
} from "../../../../../../helpers/sqft3dArHelper";
import workspace from "../../../../../canvas/core/workspace";
import LookFeaturePrice from "../../../../../../../look/lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import FeatureName from "../../../../../../../visComponents/featureName";


const SqftOptionsRelatedItemRow = (props) => {
  const { feature, index, style, partId, parentFeature, activeItemIndex, setActiveItemIndex, itemClickCallback } = props;
  const { lookViewType } = props;

  const className = useMemo(() => {
    const isActive = activeItemIndex === feature;
    // let classNames = isActive
    //   ? 'lightbox-option-single lightbox-option-selected'
    //   : 'lightbox-option-single';
    let classNames = " lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "")
    return classNames
  }, [lookViewType, activeItemIndex, feature]);
  const imageUrl = useMemo(() => feature.dbFeature.thumbnailUrl ? s3FeatureImagePath(feature.dbFeature.thumbnailUrl, THUMBNAIL_SIZES.medium) : feature.dbFeature.customThumbnail, [feature.dbFeature.thumbnailUrl, feature.dbFeature.customThumbnail]);

  const { width, height, depth } = useMemo(() => {
    const thirdPartyAR3DMetaData = getRelatedFeatureMetadata(feature, parentFeature);
    return {
      width: getWidthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData),
      height: getHeightFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData),
      depth: getDepthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData)
    };
  }, [feature, parentFeature]);

  const handleButtonClick = useCallback((e) => {
    e.preventDefault();
    setActiveItemIndex(feature);
    itemClickCallback(feature, parentFeature);
  }, [feature, parentFeature, setActiveItemIndex, itemClickCallback]);

  const setDataTransfer = (dataTransfer) => {
    dataTransfer.setData('featureId', JSON.stringify(feature.dbFeature.id));
    dataTransfer.setData('parentFeatureId', JSON.stringify(parentFeature.dbFeature.id));
    dataTransfer.setData('width', JSON.stringify(width));
    dataTransfer.setData('height', JSON.stringify(height));
    dataTransfer.setData('depth', JSON.stringify(depth),);
    dataTransfer.setData('partId', JSON.stringify(partId));

    const dragImage = new Image();
    dragImage.src = imageUrl;
    dataTransfer.setDragImage(dragImage, 0, 0);
  };

  const handleDragStart = (e) => {
    setDataTransfer(e.dataTransfer);
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const touch = e.touches[0];
    const mouseEvent = new MouseEvent('mousedown', {
      clientX: touch.clientX,
      clientY: touch.clientY,
    });

    e.target.dispatchEvent(mouseEvent);

    const dragEvent = new DragEvent('dragstart', {
      bubbles: true,
      cancelable: true,
      dataTransfer: new DataTransfer()
    });

    setDataTransfer(dragEvent.dataTransfer);

    const canvas = workspace.getCanvas();
    canvas.dispatchEvent(dragEvent);
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const touch = e.changedTouches[0];
    const mouseEvent = new MouseEvent('mouseup', {
      clientX: touch.clientX,
      clientY: touch.clientY,
    });

    e.target.dispatchEvent(mouseEvent);

    const canvas = workspace.getCanvas();
    const dropEvent = new DragEvent('drop', {
      bubbles: true,
      cancelable: true,
      clientX: touch.clientX,
      clientY: touch.clientY,
      dataTransfer: new DataTransfer()
    });

    setDataTransfer(dropEvent.dataTransfer);
    canvas.dispatchEvent(dropEvent);
  };

  return (
    <div
      className={className}
      style={style}
      key={index}
      draggable
      onDragStart={handleDragStart}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onClick={handleButtonClick}
    >
      <div className={"lm-feature__thumbnail lm-feature__thumbnail--full "}>
        {imageUrl ? <img src={imageUrl} className="feature-thumbnail__image" alt="" /> : null}
      </div>
      <div className={"lm-feature__content"}>
        <div className="lm-feature__content-name">
          {feature.getFeatureName()}
        </div>
        <div className="lm-feature__content-description">
          <span>W {width || ''} | </span>
          <span>H {height || ''} | </span>
          <span>D {depth || ''}</span>
        </div>
        <div className="lm-feature__content-price">
          <LookFeaturePrice showPriceAlways={true} lookFeature={feature} className="lm-feature__content-price-text"/>
          {lookViewType === 4 ? <FeatureName feature={feature} useCollectionName={true}/> : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { visualizersLoaded, windowHeight, isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    lookViewType,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(SqftOptionsRelatedItemRow);
